import { CompetitorsMediaInvestmentContext } from '@/dashboards/CompetitorsMediaInvestment/providers';
import { useContext } from 'use-context-selector';

export const useCompetitorsMediaInvestmentContext = () => {
    return useContext(CompetitorsMediaInvestmentContext);
};
